import { render, staticRenderFns } from "./SidebarLogoMenu.vue?vue&type=template&id=48e7d67c&scoped=true&"
import script from "./SidebarLogoMenu.vue?vue&type=script&lang=js&"
export * from "./SidebarLogoMenu.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLogoMenu.vue?vue&type=style&index=0&id=48e7d67c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7d67c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDivider,VImg})
